import { useEffect, useRef } from 'react'
import { useDispatch } from 'react-redux';
import { setViewportType, getViewportType } from '../slices/ui'

const ViewportManager = (props) => {

  const viewport = useRef(getViewportType())
  const dispatch = useDispatch()
  
  useEffect(()=>{
    const measureType = () => {
      const newViewport = getViewportType();
      if (viewport.current != newViewport){
        viewport.current = newViewport
        dispatch(setViewportType(newViewport))
      } 
    }

    window.addEventListener('resize', measureType);
    return () => {
      window.removeEventListener('resize', measureType);
    }
  }, [dispatch])

  return null
}

export default ViewportManager

